import { defineAsyncComponent } from 'vue';
import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';
import { isRelationToMonospaceFiles } from '#layers/data-model/utils/relation';

const FileSetupForm = defineAsyncComponent(() => import('#layers/data-model/components/File/SetupForm.vue'));

export default defineFieldTypeTemplate({
	type: 'relation',
	id: 'file',
	icon: 'lucide:file-image',
	name: '$t:field_types.file.name',
	description: '$t:field_types.file.description',
	sort: 1100,
	keywords: ['image', 'upload', 'attachment', 'media', 'document'],
	supportedRelationTypes: ({ context }) => {
		const { existingField } = context;

		// Prevent this template from being selected for a relation field that does not resolve to MonospaceFile.
		if (existingField && !isRelationToMonospaceFiles(existingField)) {
			return [];
		}

		return ['m2o', 'm2m'];
	},
	setupForm: FileSetupForm,
	setupDefaults: {
		target: {
			meta: {
				isHidden: true,
			},
		},
	},
});
